<div class="row project-card-v2 bg-white mb-4 mb-md-3 mx-1 mx-sm-0 py-3 px-1 rounded-4 card-fade-in">
    <div class="col-12 col-md-3">
        <div class="d-flex align-items-center justify-content-center h-100 overflow-hidden rounded-3">
            <img [routerLink]="[pathV2, dev?.d?.pid]" class="w-100 h-100 rounded-3 img-card-v2" [src]="buildImageUrl(dev, urlBaseS3)" alt="..">
        </div>
    </div>
    <div class="col-12 col-md-7">
        <div class="d-flex align-items-start justify-content-center flex-column">
            <p [routerLink]="[pathV2, dev?.d?.pid]" class="cr-pointer fs-20 fw-bold mt-md-1 mt-3 mb-2" [ngClass]="dev?.d?.state == 'fixed' ? 'primary-hover' : 'secondary-hover'">{{dev?.d?.name }}</p>
            <p [ngClass]="dev?.d?.state == 'fixed' ? 'bg-primary' : 'bg-secondary-card'" class="fs-10 px-3 cl-white rounded-4 py-1 mb-2">{{ getProjectStateText(this.dev?.d?.state || this.dev?.actualState) }}</p>
            <div class="d-flex flex-column flex-sm-row py-md-2 pt-2 pb-3 w-100 justify-content-between justify-content-md-start">
                <div class="ps-sm-1 ps-md-0 pe-sm-3 pb-2 pb-sm-0">
                    <p class="mb-1">{{ dev?.d?.state == 'fixed' ? 'Plazo:' : 'Plazo estimado:' }}</p>
                    <p class="cl-primary fw-sbold mb-0" [ngClass]="dev?.d?.state == 'fixed' ? 'cl-primary' : 'cl-secondary'">{{ dev?.d?.intervalMonthsResidential || dev?.d?.monthsEstimateResidential }}</p>
                </div>
                <div class="border-top d-block d-sm-none"></div>
                <div class="border-start d-none d-sm-block"></div>
                <div class="ps-md-3 pe-md-0 pe-3 pt-2 pt-sm-0">
                    <p class="mb-1">{{ dev?.d?.state == 'fixed' ? 'Rendimiento anual fijo:': 'TIR anual estimada:' }}</p>
                    <p class="cl-primary fw-sbold mb-0" [ngClass]="dev?.d?.state == 'fixed' ? 'cl-primary' : 'cl-secondary'">{{ dev?.d?.state == 'fixed' ? dev?.d?.performance : dev?.d?.estimatedPerformance | number }}%</p>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-md-2">
        <div class="d-flex align-items-start justify-content-center">
            <a class="btn fs-14 cl-white w-100 rounded-3" [ngClass]="dev?.d?.state == 'fixed' ? 'bg-primary' : 'bg-secondary-card'" [routerLink]="[pathV2, dev?.d?.pid]">Invertir</a>
        </div>
    </div>
</div>